import { createSelector } from 'reselect';
import TableDefinitions from '../../../../common/TableDefinitions';
import MemberPoolStorageColumns from '../../container/MemberPoolStorageListColumns';

export const getIsLoading = (state) => state.listing.MEMBER_POOL_STORAGE_PAGE.isLoading;
export const getData = TableDefinitions.MEMBER_POOL_STORAGE_PAGE.getDataFunction();
export const getColumns = createSelector(
  getData,
  MemberPoolStorageColumns,
);
